/**
 * Purpose: Normalize and validate custom domain inputs for the Domains feature.
 */

/**
 * Purpose: Normalize a hostname part (trim + lowercase).
 */
export const normalizeHostnamePart = (value: string): string => value.trim().toLowerCase();

const ROOT_DOMAIN_REGEX =
  /^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;

const SUBDOMAIN_LABEL_REGEX = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/;

/**
 * Purpose: Validate a root domain like "yourcompany.com" or "yourcompany.co.uk".
 */
export const isValidRootDomain = (rootDomain: string): boolean => {
  const normalized = normalizeHostnamePart(rootDomain);
  return ROOT_DOMAIN_REGEX.test(normalized);
};

/**
 * Purpose: Validate a single subdomain label like "apply" or "fund-portal".
 * Note: This intentionally does NOT allow dots.
 */
export const isValidSubdomainLabel = (subdomain: string): boolean => {
  const normalized = normalizeHostnamePart(subdomain);
  if (!normalized) return false;
  if (normalized.includes('.')) return false;
  return SUBDOMAIN_LABEL_REGEX.test(normalized);
};

/**
 * Purpose: Build a full custom domain hostname like "apply.yourcompany.com".
 */
export const buildCustomDomainHostname = (subdomain: string, rootDomain: string): string => {
  const normalizedSubdomain = normalizeHostnamePart(subdomain);
  const normalizedRootDomain = normalizeHostnamePart(rootDomain);
  return `${normalizedSubdomain}.${normalizedRootDomain}`;
};

